import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'nw-increment-number-input',
  templateUrl: './increment-number-input.component.html',
  styleUrls: ['./increment-number-input.component.scss'],
})
export class IncrementNumberInputComponent {
  @Input() value: number = 0;
  @Output() valueChange = new EventEmitter<number>();

  increment() {
    this.updateValue(this.value + 1);
  }

  decrement() {
    if (this.value > 0) {
      this.updateValue(this.value - 1);
    }
  }

  updateValue(newValue: number) {
    this.value = newValue;
    this.valueChange.emit(this.value);
  }

  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const newValue = parseInt(input.value);
    if (!isNaN(newValue) && newValue >= 0) {
      this.updateValue(newValue);
    }
  }
}
